import React from "react";
import { Bot, Sparkles } from "lucide-react";

/**
 * Phase 25b · AI Asset badge — gradient viola/cyan with 🤖 icon.
 * Shown on any asset with `ai_generated=true` or `creator_type=virtual`.
 */
const AI_TYPE_LABEL = {
  template: "Template",
  script: "Script",
  carousel: "Carousel",
  mini_landing: "Mini-Landing",
  video_ai: "Video AI",
};

export function AiAssetBadge({ assetAiType, size = "sm", withGlow = false }) {
  const label = AI_TYPE_LABEL[assetAiType] || "AI";
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";
  return (
    <span
      data-testid="ai-asset-badge"
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-widest ${pad} bg-white/5 text-[var(--color-text-main)] border border-white/15 ${
        withGlow ? "shadow-[0_0_16px_-4px] shadow-white/15" : ""
      }`}
    >
      <Bot className="h-3 w-3" />
      AI · {label}
    </span>
  );
}

export default AiAssetBadge;
